import { createAsyncThunk } from "@reduxjs/toolkit";
import Api from "../../Config/ApiConfig";
import { toast } from "react-toastify";

export const fetchFaqCategories = createAsyncThunk("faq/fetchCategories", async () => {
  try {
    const res = await Api.get("faqs/categories");
    if (res.data?.status_code === 200) {
      return res.data?.data;
    }
    return [];
  } catch (err) {
    toast.error(err?.message || "Failed to load categories");
    throw err;
  }
});

export const createFaqCategory = createAsyncThunk("faq/createCategory", async (payload) => {
  try {
    const res = await Api.post("faqs/categories", payload);
    if (res.data?.status_code === 200) {
      toast.success("Category created");
      return res.data?.data;
    }
    throw new Error(res.data?.message || "Failed to create category");
  } catch (err) {
    toast.error(err?.message || "Failed to create category");
    throw err;
  }
});

export const updateFaqCategory = createAsyncThunk("faq/updateCategory", async ({ categoryId, data }) => {
  try {
    const res = await Api.put(`faqs/categories/${categoryId}`, data);
    if (res.data?.status_code === 200) {
      toast.success("Category updated");
      return res.data?.data;
    }
    throw new Error(res.data?.message || "Failed to update category");
  } catch (err) {
    toast.error(err?.message || "Failed to update category");
    throw err;
  }
});

export const deleteFaqCategory = createAsyncThunk("faq/deleteCategory", async (categoryId) => {
  try {
    const res = await Api.delete(`faqs/categories/${categoryId}`);
    if (res.data?.status_code === 200) {
      toast.success("Category deleted");
      return res.data?.data;
    }
    throw new Error(res.data?.message || "Failed to delete category");
  } catch (err) {
    toast.error(err?.message || "Failed to delete category");
    throw err;
  }
});

export const fetchFaqItemsByCategory = createAsyncThunk("faq/fetchItems", async (categoryId) => {
  try {
    const res = await Api.get(`faqs/categories/${categoryId}/items`);
    if (res.data?.status_code === 200) {
      return res.data?.data;
    }
    return [];
  } catch (err) {
    toast.error(err?.message || "Failed to load FAQs");
    throw err;
  }
});

export const createFaqItem = createAsyncThunk("faq/createItem", async (payload) => {
  try {
    const res = await Api.post("faqs/items", payload);
    if (res.data?.status_code === 200) {
      toast.success("FAQ created");
      return res.data?.data;
    }
    throw new Error(res.data?.message || "Failed to create FAQ");
  } catch (err) {
    toast.error(err?.message || "Failed to create FAQ");
    throw err;
  }
});

export const updateFaqItem = createAsyncThunk("faq/updateItem", async ({ itemId, data }) => {
  try {
    const res = await Api.put(`faqs/items/${itemId}`, data);
    if (res.data?.status_code === 200) {
      toast.success("FAQ updated");
      return res.data?.data;
    }
    throw new Error(res.data?.message || "Failed to update FAQ");
  } catch (err) {
    toast.error(err?.message || "Failed to update FAQ");
    throw err;
  }
});

export const deleteFaqItem = createAsyncThunk("faq/deleteItem", async (itemId) => {
  try {
    const res = await Api.delete(`faqs/items/${itemId}`);
    if (res.data?.status_code === 200) {
      toast.success("FAQ deleted");
      return res.data?.data;
    }
    throw new Error(res.data?.message || "Failed to delete FAQ");
  } catch (err) {
    toast.error(err?.message || "Failed to delete FAQ");
    throw err;
  }
});
